import { gql } from '@apollo/client'

export const GET_ALL_MIGRANTS_TIME_LINES_BY_DOCUMENT_ID = gql`
  query getAllMigrantsTimelinesByDocumentId(
    $document_id: Int!
  ) {
    getAllMigrantsTimelinesByDocumentId(
      document_id: $document_id
    ) {
      id
      status_id
      user_id
      date_status
      text
      UserOfTimeline {
        id
        name
        id_role
        charge
        JobPositionOfUser {
          name
        }
      }
      StatusOfTimeline {
        name
        description
        progress
        color
        order
      }
    }
  }
`